import { useEffect, useRef } from "react";
import { useSearchParams, Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useVantaConnect } from "@/api/vanta";

export function AuthorizeVantaPage() {
  const [searchParams] = useSearchParams();
  const tenantId = searchParams.get("tenant") ?? "";
  const connect = useVantaConnect(tenantId);
  const called = useRef(false);

  useEffect(() => {
    if (tenantId && !called.current) {
      called.current = true;
      connect.mutate();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tenantId]);

  if (!tenantId) {
    return <Navigate to="/" replace />;
  }

  if (connect.isError) {
    return (
      <div className="flex h-full items-center justify-center">
        <div className="text-center space-y-3">
          <p className="text-danger font-medium">Failed to start Vanta authorization.</p>
          <p className="text-sm text-text-muted">Please go back and try again from the tenant settings page.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex h-full items-center justify-center">
      <div className="text-center space-y-3">
        <Loader2 className="mx-auto h-8 w-8 animate-spin text-accent" />
        <p className="text-text-secondary">Connecting to Vanta...</p>
      </div>
    </div>
  );
}
